/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'
import { Text } from 'components/'
import styles from './RadioButton.module.scss'

const RadioButton = ({ option, checked, onChange, value, name, className }) => {
  return (
    <label htmlFor={value} className={ClassNames(styles.radio, className)}>
      <span htmlFor={value} className={styles.inputGroup}>
        <input
          id={value}
          name={name}
          type="radio"
          checked={checked}
          value={value}
          onChange={onChange}
        />
        <label className={styles.labelRadio} htmlFor={value} />
      </span>
      <Text htmlFor={value} style={{ margin: '0px 5px' }} bold={checked}>
        {option}
      </Text>
    </label>
  )
}

RadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  option: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
}

RadioButton.defaultProps = {
  className: '',
}

export default React.memo(RadioButton)
